const searchPreislisten = (i, t) => { 
    const input = document.getElementById(i)
    const targets = document.querySelectorAll(t)
    input.addEventListener('keyup', e => { 
        targets.forEach(target => {
            const targetData = target.dataset.hersteller.toLowerCase()
            const inputValue = input.value.toLowerCase()
            if (targetData.indexOf(inputValue) > -1) {
                target.style.display = ""
            } else { 
                target.style.display = "none"
            }            
        })
    })
}


